// extracted by mini-css-extract-plugin
module.exports = {"pdfWrapper":"pdfRenderer_pdfWrapper__QigXh"};